import { render, staticRenderFns } from "./writtenoffloans.vue?vue&type=template&id=54331d46"
import script from "./writtenoffloans.vue?vue&type=script&lang=js"
export * from "./writtenoffloans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports